import React, { useContext } from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useModal } from "../hooks/useModal";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { AuthContext } from "../context/authContext";
import { baseUrl } from "../modules/account/login";
import { Button } from "rizzui/button";

type integrationType = "hubspot" | "google_drive";

export default function ConsentModal({ type }: { type?: integrationType }) {
  const { closeModal } = useModal();
  const { token } = useContext(AuthContext);

  const { mutate, isPending, error } = useMutation({
    mutationFn: async () => {
      return await axios
        .post(
          `${baseUrl}/integrations/${type}/get_auth_url`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          if (response.data?.data?.authUrlCode) {
            window.location.href = response.data?.data?.authUrlCode;
            closeModal();
          }
          return response;
        })
        .catch((e) => {
          return Promise.reject(
            new Error(
              e.response?.data?.details?.message ??
                "Something went wrong, try again"
            )
          );
        });
    },
  });

  return (
    <div className="w-[96%] md:w-[402px] mx-auto bg-background dark:bg-[#2A2C30] p-[32px] rounded-[8px] shadow-lg">
      <div className="flex flex-col gap-[41px] text-center">
        <div className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Read & write access
          </Text>
          <Text className="font-switzer text-[14px] text-[#758599] font-[400] w-[298px] mx-auto">
            Clicking on “I agree, proceed” means you’re giving us read & write
            access to your CRM
          </Text>
        </div>
        <div className="flex gap-[18px] justify-center">
          <Button
            className="w-[109px] h-[35px] rounded-[4px] !bg-[#F2F2F2]"
            onClick={() => {
              closeModal();
            }}
          >
            <Text className="font-[400] text-[12px] text-[#191919] font-switzer">
              I don't agree
            </Text>
          </Button>
          <Button
            type="button"
            className="min-w-[109px] !h-[35px] rounded-[4px] !bg-btn py-[9px] px-[12px]"
            onClick={() => {
              mutate();
            }}
            isLoading={isPending}
          >
            <Text className="font-[400] w-full text-[12px] text-background font-switzer">
              I agree, proceed
            </Text>
          </Button>
        </div>
      </div>
      {error && (
        <Text className="text-red-500 text-center mt-4 font-[400] font-switzer text-[12px]">
          {error.message}
        </Text>
      )}
    </div>
  );
}
